/* global translations */
/* eslint no-underscore-dangle: ['error', { allow: [
  _vipOn, _vipName, _loading, _error, _errors,
] }] */
import { EventEmitter } from 'events';
import assign from 'object-assign';
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const CHANGE_EVENT = 'change';

let _vipOn = false;
let _vipIcon = false;
let _vipName = '';
let _loading = false;
let _error = '';
let _errors = {};

const VipStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  setVipOn(value) {
    _vipOn = value;
  },

  getVipOn() {
    return _vipOn;
  },

  setVipIcon(value) {
    _vipIcon = value;
  },

  getVipIcon() {
    return _vipIcon;
  },

  setVipName(name) {
    _vipName = name;
  },

  getVipName() {
    return _vipName;
  },

  setLoading(value) {
    _loading = value;
  },

  getLoading() {
    return _loading;
  },

  setError(error) {
    _error = error;
  },

  getError() {
    return _error;
  },

  setErrors(errors) {
    _errors = errors;
  },

  getErrors() {
    return _errors;
  },
});

VipStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.VIP_SAVE_SETTINGS_SUCCESS: {
      window.location.href = '/vip';
      // VipStore.setLoading(false);
      // VipStore.emitChange();
      break;
    }
    case ActionTypes.VIP_SAVE_SETTINGS_ERROR: {
      if (action.msg !== undefined) {
        VipStore.setError(action.msg);
      } else if (action.errors !== undefined) {
        VipStore.setErrors(action.errors);
      } else {
        VipStore.setError(get(translations, 'txt: Nezināma kļūda', ''));
      }
      VipStore.setLoading(false);
      VipStore.emitChange();
      break;
    }
    default:
      // do nothing
  }
});

module.exports = VipStore;
